module.exports = __webpack_public_path__ + "static/media/Уфимская В.А. (ММ).54081ded.pdf";